/**
 * IANA time zones for booking math. Abbreviations like EST are UTC-5
 * year-round in moment-timezone and Intl — that is the Sam 8 AM / 9 AM bug.
 */

const ABBREVIATION_TO_IANA = {
  est: 'America/New_York',
  edt: 'America/New_York',
  est5edt: 'America/New_York',
  'us/eastern': 'America/New_York',
  'etc/gmt+5': 'America/New_York',
  'etc/gmt+05': 'America/New_York',
  'eastern standard time': 'America/New_York',
  'eastern daylight time': 'America/New_York',
  cst: 'America/Chicago',
  cdt: 'America/Chicago',
  'us/central': 'America/Chicago',
  'etc/gmt+6': 'America/Chicago',
  mst: 'America/Denver',
  mdt: 'America/Denver',
  'us/mountain': 'America/Denver',
  'etc/gmt+7': 'America/Denver',
  pst: 'America/Los_Angeles',
  pdt: 'America/Los_Angeles',
  'us/pacific': 'America/Los_Angeles',
  'etc/gmt+8': 'America/Los_Angeles',
};

/**
 * DST-aware IANA zone. Fixed-offset EST/EDT/Etc/GMT+5 become America/New_York.
 *
 * @param {string} [timeZone]
 * @returns {string}
 */
const canonicalizeTimeZone = timeZone => {
  if (typeof timeZone !== 'string') {
    return '';
  }
  const trimmed = timeZone.trim();
  if (!trimmed) {
    return '';
  }
  const mapped = ABBREVIATION_TO_IANA[trimmed.toLowerCase()];
  return mapped || trimmed;
};

/**
 * Listing availability timezone, DST-aware.
 *
 * @param {string} [raw]
 * @param {string} [fallback]
 * @returns {string}
 */
const listingTimeZone = (raw, fallback = 'America/New_York') =>
  canonicalizeTimeZone(raw) || canonicalizeTimeZone(fallback) || 'America/New_York';

module.exports = {
  canonicalizeTimeZone,
  listingTimeZone,
};
